import React from "react";
import { useSelector } from "react-redux";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "./Contract.css";
import { Store } from "../../../Redux/store";
import { sidebarTabs } from "../../../Redux/Actions/sidebarButtons";

const MoreCaseDetails = () => {
  const { contractdata } = useSelector((state) => state.contractresponse);

  const handleGoback = () => {
    Store.dispatch(sidebarTabs("contract"));
  };

  return (
    <div className="w-full overflow-y-auto flex flex-col gap-2">
      <div className="w-full px-4 py-3 bg-[white] flex items-center justify-between">
        <span className="font-bold text-[16px]">
          PCC Order Request for Skyteams Travels and Tours Limited
        </span>

        <div
          className="bg-[#2196F3] px-4 py-2 text-[13px] text-[white] cursor-pointer shadow hover:shadow-md"
          onClick={handleGoback}
        >
          Back
        </div>
      </div>
      <div className="w-full h-full flex gap-5 relative">
        <div className="mx-auto p-4 w-[75%] tablets:w-full">
          <div className="mb-4 bg-[white] w-fit py-3 px-6 border_buttom">
            <h2 className="text-lg font-bold">Case Number:</h2>
            <p className="text-sm text-gray-600">CF/240324/3807</p>
          </div>

          <div className="mb-4 w-full">
            <VerticalTimeline>
              {contractdata.map((t, i) => {
                // const contentStyle =
                //   i === 0
                //     ? {
                //         background: "rgb(33, 150, 243)",
                //         color: "white",
                //         borderLeft: "7px solid  rgb(33, 150, 243)",
                //       }
                //     : undefined;
                // const arrowStyle =
                //   i === 0
                //     ? { borderRight: "7px solid  rgb(33, 150, 243)" }
                //     : undefined;

                return (
                  <VerticalTimelineElement
                    key={i}
                    className="vertical-timeline-element--work"
                    // contentStyle={contentStyle}
                    // contentArrowStyle={arrowStyle}
                    date={t.date}
                    {...t.icon}
                  >
                    {t.title ? (
                      <React.Fragment>
                        <h3 className="vertical-timeline-element-title">
                          {t.title}
                        </h3>
                        {t.subtitle && (
                          <h4 className="vertical-timeline-element-subtitle">
                            {t.subtitle}
                          </h4>
                        )}
                        {t.desc && <p>{t.desc}</p>}
                      </React.Fragment>
                    ) : undefined}
                  </VerticalTimelineElement>
                );
              })}
            </VerticalTimeline>
          </div>
        </div>

        <div className="w-[25%] bg-[#fffeff] flex sticky gap-4 top-0 flex-col p-3 tablets:hidden">
          <span className="font-bold text-[14px]">Agency Information</span>
          <div className="w-full flex flex-col gap-3 p-3 border_class">
            <span className="text-[14px] font-[700]">
              Skyteams Travels and Tours Limited
            </span>

            <div className="flex flex-col justify-start">
              <span>13, Toluwalase Street,</span>
              <span>P : 08103948576</span>
              <span>E : gbengasamuel@gmail.com</span>
              <span>Iata No. : Not available</span>
              <span>NANTA No. : Not available</span>
            </div>

            <div className="flex flex-col justify-start">
              <span className="font-[600] text-[13px]">Director</span>
              <span>Adekoya Gbenga Samuel</span>
              <span>P: 08103948576</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoreCaseDetails;
